<template>
  <div v-if="backdrop">
    <div
      class="modal fade"
      :class="modal.open ? 'show' : ''"
      style="display: block"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      @click="$event.target.classList.contains('modal') ? close() : true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ config.title || 'Detail' }}</h5>
            <button type="button" class="close" @click="close()" v-html="ic('close')" />
          </div>

          <div class="modal-body" ref="modal">
            <div class="row">
              <div class="col-md-4 ">
                <label class="form-label">NIK</label>
                <p class="form-control-plaintext">{{ data.nik || '-' }}</p>
              </div>
              <div class="col-md-4 ">
                <label class="form-label">Nama</label>
                <p class="form-control-plaintext">{{ data.name || '-' }}</p>
              </div>
              <div class="col-md-4 ">
                <label class="form-label">Nama Panggilan</label>
                <p class="form-control-plaintext">{{ data.final_name || '-' }}</p>
              </div>
            </div>

            <hr class="my-1" />

              <div class="row">
              <div class="col-md-4 ">
                <label class="form-label">Last Login At</label>
                <p class="form-control-plaintext">{{ data.last_login_at || '-' }}</p>
              </div>
              <div class="col-md-8 ">
                <label class="form-label">Device Information</label>
                <p class="form-control-plaintext">{{ data.device_information || '-' }}</p>
              </div>
            </div>

            <hr class="my-1" />

            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">Email</label>
                <p class="form-control-plaintext">{{ data.email || '-' }}</p>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Nomor Telepon</label>
                <p class="form-control-plaintext">{{ data.phone || '-' }}</p>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label">Alamat</label>
              <p class="form-control-plaintext">{{ data.address || '-' }}</p>
            </div>

            <hr class="my-1" />

            <div class="row">
              <div class="col-md-6 ">
                <label class="form-label">Perusahaan</label>
                <p class="form-control-plaintext">
                  <span
                    v-for="(p, index) in data.perusahaan"
                    :key="index"
                    class="badge bg-primary mx-1"
                  >
                    {{ p.kode_perusahaan }} - {{ p.nama_perusahaan }} 
                  </span>
                  <span v-if="data.perusahaan.length === 0">-</span>
                </p>
              </div>
              <div class="col-md-6 ">
                <label class="form-label">Depo</label>
                <p class="form-control-plaintext">
                  <span
                    v-for="(d, index) in data.depo"
                    :key="index"
                    class="badge bg-success mx-1"
                  >
                    {{ d.nama_depo }} 
                  </span>
                  <span v-if="data.depo.length === 0">-</span>
                </p>
              </div>
            </div>

            <div class="">
              <label class="form-label">Role</label>
              <p class="form-control-plaintext">
                <span
                  v-for="(r, index) in data.roles"
                  :key="index"
                  class="badge bg-info text-dark mx-1"
                >
                  {{ r.name }}
                </span>
                <span v-if="data.roles.length === 0">-</span>
              </p>
            </div>

            <div class="mb-3">
              <label class="form-label">Gudang</label>
              <p class="form-control-plaintext">
                <span
                  v-for="(g, index) in data.gudang"
                  :key="index"
                  class="badge bg-secondary mx-1"
                >
                  {{ g.nama_gudang }} 
                </span>
                <span v-if="data.gudang.length === 0">-</span>
              </p>
            </div>
          </div>

          <div class="modal-footer pt-2">
            <button type="button" class="btn btn-white" @click="close()">Tutup</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-backdrop fade" :class="modal.open ? 'show' : ''" />
  </div>
</template>


<script>
import helper from "@/assets/js/helper.js";
import { mapActions, mapState } from "vuex";

export default {
  name: "view",
  props: {
    config: {
      default: {
        view: false,
        title: "Detail Modal"
      }
    },
    initData: null,
  },
   mixins: [helper],


  data() {
    return {
      backdrop: false,
      modal: {
        open: false,
      },
      data: {
        nik: '',
        name: null,
        final_name: null,
        email: null,
        phone: null,
        last_login_at: null,
        device_information: null,
        roles: [],
        depo: [],
        gudang: [],
        perusahaan: [],
        address: null,
      },
    };
  },

  computed: {
    ...mapState(["loading"]),
  },

  methods: {
    close() {
      this.$emit("update:config", { view: false });
    },

    _getPerusahaan() {
      this.getListPerusahaan().then((res) => {
        this.perusahaan = res.data;
      });
    },

    _getRoles() {
      this.axios
        .get("role")
        .then((res) => {
          this.roles = res.data.data;
        })
        .catch((err) => {
          this.onError(err);
        });
    },

    _getDepo(id) {
      if (typeof id === "undefined" || id.length === 0) {
        this.depos = [];
      } else {
        this.getListDepo({ id_perusahaan: id, filter: true }).then((res) => {
          this.depos = res;
        });
      }
    },

    _getGudang() {
      this.axios
        .get("gudang")
        .then((res) => {
          this.gudangs = res.data.data;
        })
        .catch((err) => {
          this.onError(err);
        });
    },
  },

  watch: {
    "config.view": function (view) {
  if (view) {
    this.backdrop = true;

    setTimeout(() => {
      this.modal.open = true;
      Promise.all([
        this._getPerusahaan(),
        this._getRoles(),
        this._getGudang()
      ])
      .catch(err => {
        this.onError(err);
      });
    }, 100);
  } else {
    this.modal.open = false;
    setTimeout(() => {
      this.backdrop = false;
    }, 100);
  }
},

    initData: function (data) {
      Object.assign(this.$data.data, this.$options.data.call(this).data);

      if (data != null) {
        for (const key in this.data) {
          if (
            key !== "roles" &&
            key !== "depo" &&
            key !== "gudang" &&
            key !== "perusahaan"
          )
            this.data[key] = data[key];
        }

     this.data.perusahaan = data.perusahaan || [];
        this.data.roles = data.roles || [];
        this.data.depo =data.depo || [];
        this.data.gudang = data.gudang || [];
      }
    },
  },
};
</script>
